export default "__VITE_ASSET__BMS3WcLR__"